<template>
  <el-container direction="vertical">
    <el-row>
      <el-col :span="5">
        <el-input v-model="params.user_name" prefix-icon="el-icon-search" placeholder="输入用户名称查询" clearable @change="onSearch()" />
      </el-col>

      <el-col :span="5">
        <el-select v-model="params.user_roles" placeholder="选择用户角色查询" clearable @change="onSearch()">
          <el-option
            v-for="item in share.roleList"
            :key="item.value"
            :label="item.text"
            :value="item.value">
          </el-option>
        </el-select>
      </el-col>

      <el-col :span="5" class="col_pos_right" align="right">
        <el-button v-permission="'增加用户'" icon="el-icon-plus" @click="addUser()">添加用户</el-button>
        <el-button class="btn btn_1" @click="onSearch()">刷新</el-button>
      </el-col>
    </el-row>

    <el-container>
      <el-table :data="pageData.items" stripe border :height="$setTableHeight(1, 0)" :header-cell-style="{textAlign: 'center'}" :cell-style="{textAlign: 'center'}">
        <el-table-column v-for="it in tableColList" :key="it.key" :label="it.name" :fixed="it.fixed">
          <template slot-scope="scope">
            <template v-if="it.key === 'head_image_url'">
              <img v-if="scope.row[it.key]" :src="scope.row[it.key]" class="headImg" alt="头像加载失败" srcset="">
              <span v-else>暂无头像</span>
            </template>
            <span v-else-if="it.key === 'user_roles_desp'">{{scope.row[it.key].join(',')}}</span>
            <span v-else-if="it.key === 'is_validated'">{{scope.row[it.key] ? '是' : '否'}}</span>
            <span v-else>{{scope.row[it.key]}}</span>
          </template>
        </el-table-column>

        <el-table-column fixed="right" width="220" label="操作">
          <template slot-scope="scope">
            <el-link v-for="item in $operationsFilter(operations)" :key="item.key" :type="item.type" @click="handleClick(item.operation, scope.row)">{{ item.title }}</el-link>
          </template>
        </el-table-column>
      </el-table>
    </el-container>

    <el-pagination
      background
      style="margin-top:14px"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageData.total"
      :current-page="pageData.page"
      @current-change="onPageChange"
      :page-size="params.max_results"
      :page-sizes="$pageSizes"
      @size-change="onPageSizeChange">
    </el-pagination>

    <el-dialog width="600px" :title="title" :visible.sync="dialogVisible" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" @closed="componet_select = ''">
      <component :is="componet_select" :rowData="rowData" :roleList="share.roleList" @tableCloseDialog="dialogVisible = false" />
    </el-dialog>
  </el-container>
</template>

<script>
import Backend from '@/api/backend'
import userAdd from './add'
import userEdit from './edit'
import { getLoginUserInfo } from '@/api/permission'

export default {
  data () {
    return Backend.initListPage(this, 'user', {
      route_name: '用户管理列表',
      id_name: 'user_id',
      tableColList: [
        {
          key: 'user_id',
          name: '用户ID',
          fixed: true
        },
        {
          key: 'head_image_url',
          name: '用户头像'
        },
        {
          key: 'user_name',
          name: '用户名称'
        },
        {
          key: 'login_name',
          name: '用户账号'
        },
        {
          key: 'user_roles_desp',
          name: '用户角色'
        },
        {
          key: 'mobile',
          name: '用户电话'
        },
        {
          key: 'is_validated',
          name: '手机号是否校验'
        },
        {
          key: 'mail',
          name: '用户邮箱'
        }
      ],
      params: {
        user_name: '',
        user_roles: ''
      },
      operations: [
        {
          key: 'resetPassword',
          title: '重置密码',
          icon: 'icon-zhongzhimima icon_11',
          permiss: '重置密码',
          type: 'success',
          operation: 'resetPassword'
        },
        {
          key: 'edit',
          title: '编辑',
          icon: 'icon-bianji icon_1',
          permiss: '编辑用户',
          type: 'primary',
          operation: 'editRow'
        },
        {
          key: 'delete',
          title: '删除',
          icon: 'icon-shanchu icon_6',
          permiss: '删除用户',
          type: 'danger',
          operation: 'deleteRow'
        }
      ],
      share: {
        roleList: []
      },
      dialogVisible: false,
      title: '添加用户',
      componet_select: '',
      rowData: {}
    })
  },
  components: {
    'user-add': userAdd,
    'user-edit': userEdit
  },

  created () {
    this.getRoleList()
  },

  methods: {
    getRoleList () {
      Backend.filterKeyValueList(this, 'role').then((data) => {
        if (getLoginUserInfo().isOnlyAfterSalesManage) {
          this.share.roleList = data.filter(it => it.value === '5')
          return
        }
        this.share.roleList = data.filter(it => it.value !== '0')
      })
    },
    addUser () {
      this.title = '添加用户'
      this.dialogVisible = true
      this.componet_select = 'user-add'
    },
    onSearch () {
      Backend.queryList(this, this.pageData.filter, 0)
    },
    onPageChange (v) {
      Backend.queryList(this, this.pageData.filter, v)
    },
    onPageSizeChange (v) {
      this.params.max_results = v
      Backend.queryList(this, this.pageData.filter, this.pageData.page === 0 ? 1 : this.pageData.page)
    },
    handleClick (operation, row) {
      this[operation](row)
    },
    resetPassword (row) {
      this.$confirm('是否重置密码？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        Backend.post(this, 'user/reset_password', {
          user_id: row.user_id
        }).then(() => {
          this.$message.success('重置密码成功!')
        })
      })
    },
    editRow (row) {
      this.title = '编辑用户'
      this.dialogVisible = true
      this.componet_select = 'user-edit'
      this.rowData = row
    },
    deleteRow (row) {
      Backend.deleteRow(this, row, '用户管理')
    }
  }
}
</script>

<style lang="scss" scoped>
  .headImg{
    width: 40px;
    height: 40px;
  }
</style>
